import PropTypes from "prop-types"
import { useMemo } from "react"
import { useRemarkSync } from "react-remark"
import { Link } from "react-router-dom"

import Button from "components/ui/button"
import { cn } from "styles/utils"

const getComponents = (defaultClassName, classNames) => ({
  a: ({ href, ...props }) => (
    <Button
      asChild
      className={cn(defaultClassName, classNames?.anchorClassName)}
      text
      underline
    >
      <Link data-lc="countdown-banner" to={href} {...props} />
    </Button>
  ),
  p: ({ ...props }) => (
    <p
      className={cn("inline", defaultClassName, classNames?.paragraphClassName)}
      {...props}
    />
  ),
})

const MicroBannerMarkdown = ({ children, classNames, defaultClassName }) => {
  const components = useMemo(
    () => getComponents(defaultClassName, classNames),
    [defaultClassName, classNames]
  )
  const markdownContent = useRemarkSync(children, {
    rehypeReactOptions: { components },
    supressHydrationWarning: true,
  })

  return markdownContent
}

MicroBannerMarkdown.propTypes = {
  children: PropTypes.string,
  classNames: PropTypes.object,
  defaultClassName: PropTypes.string,
}

export default MicroBannerMarkdown
